import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Card } from '@components/card';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';
import type { IJobStage } from 'models/types';
import type { JobStatistics } from 'types/jobs';

type Props = {
  stages: Array<IJobStage>;
  statistics: JobStatistics;
};

export const ApplicantsByStage = observer<Props>(function ApplicantsByStage({
  stages,
  statistics,
}) {
  const { t } = useStore();
  return (
    <Stack space={2}>
      <Text font="semibold14" color="purple100" text={t('job.statistics.bystage')} />
      <Container>
        {stages.map((stage) => (
          <Stage key={stage.id} name={stage.name} count={statistics.jobStages[stage.id] || 0} />
        ))}
      </Container>
    </Stack>
  );
});

const Stage = observer<{ name: string; count: number }>(function Stage({ name, count }) {
  return (
    <Card space={6}>
      <Stack space={4} justify="space-between" orientation="horizontal" align="center">
        <Text ellipsis font="bold14" color="purple100" text={name} />
        <Text font="bold16" color="purple60" text={count} />
      </Stack>
    </Card>
  );
});

const Container = styled.div({
  display: 'grid',
  gap: '1.5rem',
  gridTemplateColumns: 'repeat(auto-fit, minmax(15rem, auto))',
  '@media(max-width: 1280px)': {
    gap: '1rem',
  },
});
